import { useMutation, gql } from '@apollo/client';
import {
  EditarCursoMutation,
  EditarCursoMutationVariables,
} from './__generated__/EditarCursoMutation';

const EDITAR_CURSO_MUTATION = gql`
  mutation EditarCursoMutation(
    $id_curso: Int!
    $id_unidade: Int
    $dsc_nome_curso: String
    $dsc_sigla_curso: String
    $dsc_nome_apoio: String
    $dsc_email_apoio: String
    $dsc_telefone_apoio: String
    $ativo: Boolean!
  ) {
    editarCurso(
      input: {
        id_curso: $id_curso
        id_unidade: $id_unidade
        dsc_nome_curso: $dsc_nome_curso
        dsc_sigla_curso: $dsc_sigla_curso
        dsc_nome_apoio: $dsc_nome_apoio
        dsc_email_apoio: $dsc_email_apoio
        dsc_telefone_apoio: $dsc_telefone_apoio
        ativo: $ativo
      }
    ) {
      id_curso
      id_unidade
      dsc_nome_curso
      dsc_sigla_curso
      dsc_nome_apoio
      dsc_email_apoio
      dsc_telefone_apoio
      ativo

      ofertas {
        id_oferta
        num_oferta
        num_ano
        num_semestre
        ativa
        dsc_email_assistente
        dat_inicio
        dat_fim

        turmas {
          id_turma
          id_horario
          num_turma
          dias_semana
          ativa
        }
      }
    }
  }
`;

const useEditarCursoMutation = () => {
  return useMutation<EditarCursoMutation, EditarCursoMutationVariables>(EDITAR_CURSO_MUTATION);
};

export { useEditarCursoMutation };
